module.exports = "/assets/images/thinking.png";